import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { BannersConfig } from '@frontend/sports/common/client-config-data-access';
import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { BannerViewModel } from '@frontend/sports/types/components/banners/models';
import { DeviceService } from '@frontend/vanilla/core';

import { BannerEsportComponent } from './banner-esport.component';
import { BannerGamesComponent } from './banner-games.component';
import { BannerJackpotComponent } from './banner-jackpot.component';
import { ofType } from './banner.model';
import { BannersService } from './banners.service';
import { CasinoBannerLinkComponent } from './casino-banner-link.component';
import { SportBannerLinkComponent } from './sport-banner-link.component';
import { VymlComponent } from './vyml.component';

@Component({
    selector: 'ms-banner',
    templateUrl: 'banner.component.html',
    imports: [
        CasinoBannerLinkComponent,
        SportBannerLinkComponent,
        BannerJackpotComponent,
        BannerGamesComponent,
        VymlComponent,
        BannerEsportComponent,
    ],
})
export class BannerComponent implements OnInit {
    @Input() position = '';
    @Input() order: '' | 'first' | 'last';
    @Input() pageName = '';

    banner?: BannerViewModel;
    type = '';
    typeClass = '';
    isVymlEnabled: boolean;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        private bannersService: BannersService,
        private bannersConfig: BannersConfig,
        private device: DeviceService,
    ) {}

    ngOnInit(): void {
        this.typeClass = this.dashCase(this.position);
        this.isVymlEnabled = this.bannersConfig.virtuals.enabledPages.indexOf(this.pageName) > -1;
        this.getBanners();
    }

    get isVisible(): boolean {
        return !!this.banner && !this.device.isRobot;
    }

    private getBanners(): void {
        this.bannersService.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((data: BannerViewModel[]) => {
            let items: BannerViewModel[];
            if (this.pageName === RouteTag.SportList || this.pageName === RouteTag.LiveSport || this.pageName === RouteTag.Horses) {
                items = data.filter((x) => 'vyml' === x.type.toLowerCase());
            } else {
                items = data.filter((x) => this.position.toLowerCase() === x.source + 'banner');
            }
            this.updateData(items[0]);
        });
    }

    private updateData(item?: BannerViewModel): void {
        this.type = item ? item.type.toLowerCase() : '';
        this.banner = item;
    }

    private dashCase(text: string): string {
        return text.replace(/([A-Z])/g, (g) => `-${g[0].toLowerCase()}`).substring(1);
    }

    protected readonly ofType = ofType;
}
